<template>
  <div class="container mt-2" >
      <div class="row">
        <!-- Right Column for Image Preview -->
        <div class="col-md-12">
          <div class="image-preview text-center">
            <!-- <h2>Image Preview</h2> -->
            <img :src="currentField.imagepath" alt="Image Preview" class="img-fluid" :style="'height:'+currentField.size+'px; !important' ">
          </div>
        </div>

        <!-- Left Column for Description -->
        <div class="col-md-12" v-if="currentField.imagetext && currentField.imagetext.length > 1">
          <div v-html="currentField.imagetext"></div>
        </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUpload',

  props: ['currentField'],
  data() {
    return {
      // input: ''
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>